// extracted by mini-css-extract-plugin
export default {"buyCourseBtn":"BuyCourseBtn_buyCourseBtn__BnUbJ","openBtn":"BuyCourseBtn_openBtn__z0W4c"};